import React, { useState } from "react";
import AsyncSelect from "react-select/async";
import { searchServices } from "../http";
import styles from "./MultiServiceSelect.module.scss"; // Assuming your styles are in a separate SCSS file

const MultiServiceSelect = ({ onServicesChange, placeholder }) => {
  const [selectedServices, setSelectedServices] = useState([]);

  const loadServices = async (inputValue) => {
    if (!inputValue.trim()) return [];
    try {
      const fetchedServices = await searchServices(inputValue);
      return fetchedServices.map((service) => ({
        value: service.id,
        label: service.name + (service.is_complex ? " (Complex)" : ""),
        is_complex: service.is_complex,
      }));
    } catch (error) {
      console.error("Error fetching services:", error);
      return [];
    }
  };

  const handleChange = (selectedOptions) => {
    const selected = selectedOptions.map((option) => ({
      id: option.value,
      name: option.label,
      is_complex: option.is_complex,
    }));
    setSelectedServices(selected);
    onServicesChange(selected);
  };

  return (
    <div className={styles.inputContainer}>
      <label className={styles.label}>{placeholder}</label>
      <AsyncSelect
        isMulti
        cacheOptions
        defaultOptions
        loadOptions={loadServices}
        onChange={handleChange}
        placeholder={placeholder}
        value={selectedServices.map((service) => ({
          value: service.id,
          label: service.name,
        }))}
        styles={{
          control: (base) => ({
            ...base,
            backgroundColor: "white",
            borderColor: "#ced4da",
            boxShadow: "none",
            "&:hover": {
              borderColor: "#80bdff",
            },
            borderRadius: "var(--input-border-radius)",
            padding: "0.5rem", 
          }),
          multiValue: (base) => ({
            ...base,
            backgroundColor: "#f1f4f8",
            color: "#495057",
            borderRadius: "var(--input-border-radius)", 
          }),
          multiValueLabel: (base) => ({
            ...base,
            color: "#495057",
          }),
          multiValueRemove: (base) => ({
            ...base,
            color: "#d9534f",
            ":hover": {
              backgroundColor: "#f5c6cb",
              color: "#a94442",
            },
          }),
          placeholder: (base) => ({
            ...base,
            color: "var(--input-placeholder-color)", 
          }),
        }}
      />
    </div>
  );
};

export default MultiServiceSelect;
